export const tr = {
    'empty-priority': 'Belirtilmedi',
    title: 'Otomatik bütçe önceliğinin düzenlenmesi'
};
